<template>
  <router-view />
</template>

<script>
export default {
  watch: {
    $route(val) {
      if (val.name === "AdministratorSystemInvoices") {
        this.$router.push({ name: "AdministratorNewInvoices" });
      }
    },
  },
};
</script>
